/** 显示loading的请求数量 默认-1 当前没有请求 */
export let requrstShowLoadingCount = -1

export function setRequrstShowLoadingCount(value) {
  requrstShowLoadingCount = value
}

/** 关闭loading的SetTimeout */
export let requrstShowLoadingTimer = 0

export function setRequrstShowLoadingTimer(value) {
  requrstShowLoadingTimer = value
}

/** 显示错误信息的状态 默认false */
export let requrstShowErrorState = false

export function setRequrstShowErrorState(value) {
  requrstShowErrorState = value
}

/** 连续重发http请求记录 */
export let reloadCount = {}

export function setReloadCount(value) {
  reloadCount = value
}
